module.exports = __webpack_public_path__ + "img/lifestyle.4f39dce9.jpg";